<template>
  <div class="modal-overlay">
    <button class="close-btn" @click="closeRulesModal()">✕</button>

    <div class="modal-content">
      <!-- Текст -->
      <div class="body">
        <h2>ПРАВИЛА ПОЛЬЗОВАНИЯ КАРТОЙ</h2>

        <p>
          1. Для прохождения на следующий этап коллективу необходимо принять участие в любом офлайн конкурсе от движения “Танцуй, Россия!”. После участия в вашем личном электронном кабинете автоматически появится печать, подтверждающая ваше участие и переход на следующий уровень.
        </p>

        <p>
          2. Если стоит отметка в личном электронном кабинете давности более 1 года, то коллектив не может претендовать на привилегии данного этапа. Он автоматически возвращается назад к этапу карты “Выдача стипендии” и заново движется по этапам, участвуя в наших конкурсах.

        </p>

        <p>
          3. Для того, чтобы стабильно продвигаться по этапам карты резидента/президента и получать самые крутые привилегии от МХД "Танцуй, Россия!" необходимо участвовать хотя бы 1 раз в год на офлайн конкурсах.

        </p>

        <p>
          4. Если коллектив не участвовал в любых наших офлайн конкурсах уже более 6 месяцев - стипендия обнуляется и перестает копиться и выдаваться. Совет: участвовать в любом нашем офлайн проекте хотя бы 1 раз в пол года для того, чтобы копилась большая стипендия и не обнулялась.

        </p>
        <p>
          5. Если коллектив принимал участие в каком-либо нашем проекте и не потратил всю накопившуюся стипендию на данном проекте, то при соблюдении всех вышеупомянутых условий, он может воспользоваться остатком стипендии на следующем проекте (если реализация проекта             не позднее 6 месяцев от срока того, в котором участвовал коллектив)
        </p>
        <p>
          6. Для того чтобы воспользоваться бонусами карты резидента/президента руководителю коллектива нужно заполнить google форму в личном кабинете или запросите ее у своего куратора. Таким образом отдел бронирования или отдел снабжения возьмет заявку в работу.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { useModalStore } from "@/stores/modals";
export default {
  setup() {
    const modalStore = useModalStore();
    return { modalStore };
  },
   methods: {
    closeRulesModal() {
      this.modalStore.closeRulesModal();
    },

  },
};
</script>

<style scoped lang="scss">
.modal-overlay {
  position: fixed;
  inset: 0;
  background: #fff;
  z-index: 1000;
  padding-top: 2vw;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

/* Кнопка закрытия */
.close-btn {
  position: fixed;
  top: 16px;
  right: 16px;
  font-size: 26px;
  background: none;
  border: none;
  cursor: pointer;
  z-index: 1100;
}

/* Контент */
.modal-content {
  max-width: 900px;
  margin: 0 auto;

  padding: 10vw 30vw 5vw;
}

/* 📱 Телефон */
@media (max-width: 768px) {

  .modal-content {
    max-width: 900px;
    margin: 0 auto;

    padding: 100vw 10vw 5vw;
  }


}
</style>
